import React, { useState } from "react";
import CaSideNav from "../../../components/AdminComponents/CaSideNav";
import SecondaryNav2 from "../../../components/AdminComponents/SecondaryNav2";
import {
  CaAdminMenu,
  CaAdminSettingsMenu,
  SecondaryNavCaAdmin,
} from "../../../components/AdminComponents/MenuItems";
import {
  Table,
  Popconfirm,
  Spin,
  message,
  Pagination,
  Switch,
  Tooltip,
  Tag,
} from "antd";
import { DeleteTwoTone, SwapOutlined } from "@ant-design/icons";
import EditableImage from "../../../components/icons/EditIcon";

import { useSelector } from "react-redux";
import Axios from "../../../api/Axios";

import { getUpdateStatus } from "../../../components/AdminComponents/ViewUpdateIndex";
import {
  capitalizeWords,
  remainingViewportHeight,
} from "../../../components/icons/ApplicationColor";
import CommonTopDetails from "../../../components/AdminComponents/CommonTopDetails";
import { useLocation, useNavigate } from "react-router-dom";
import useCommonListing from "../../../components/AdminComponents/customHooks/useCommonListing";
import AddEditRoles from "../../../components/AdminComponents/Modals/AddEditRoles";

const WorkRoleListing = () => {
  const userInfo = useSelector((state) => state.user);
  const [messageApi, contextHolder] = message.useMessage();
  const [loadAgain, setLoadAgain] = useState(false);
  const LoadAPI = () => {
    setLoadAgain((prev) => !prev);
  };

  const {
    data,
    itemsLength,
    loading,
    filterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
    handleSwitchChange,
    // setFilterData,
    // handleClearAll,
    // setFilterUrl,
  } = useCommonListing({
    passSize: 15,
    passPage: 1,
    passURL: `learn/workrole/?type=work_role&organization_id=${userInfo.data.organization.id}`,
    loadAgain: loadAgain,
    // includeStatus: false,
  });
  const location = useLocation();
  const isSettingsPage = location.pathname.includes("settings"); // true if 'settings' in URL
  // eslint-disable-next-line no-unused-vars
  const { pageSize, currentPage, active, filter_url } = filterData;
  const updateAuth = getUpdateStatus(userInfo, 0, 5);
  const [visible, setVisible] = useState(false);
  const [editData, setEditData] = useState();
  const [isEditing, setIsEditing] = useState(false);
  const history = useNavigate();
  const handleRowClick = (record) => {
    if (isSettingsPage) {
      history(`/settings/work-roles/edit/${record.id}`);
    } else {
      setEditData(record);
      setIsEditing(true);
      setVisible(true);
    }
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const handleCancel = () => {
    setVisible(false);
    setEditData(null);
    setIsEditing(false);
  };
  const csrfToken = getCookie("csrftoken");
  const handleDeletePer = async (record) => {
    try {
      await Axios.delete(`/location/${record?.id}/`, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });

      LoadAPI();
      DeleteLocation("success");
    } catch (err) {
      //console.log(err, "error");
      DeleteLocation("error");
    }
  };
  // eslint-disable-next-line no-unused-vars
  const handleDelete = async (record) => {
    //console.log("coming here", record.id);
    const data = {
      status: false,
    };
    try {
      await Axios.put(`/location/${record?.id}/`, data, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });

      LoadAPI();
      InactiveLocation("success", "Location has been Archived");
    } catch (err) {
      //console.log(err, "error");
      InactiveLocation("error", err?.response?.data?.detail);
    }
  };
  const UnarchiveLocation = async (record) => {
    //console.log("coming here", record.id);
    const data = {
      status: true,
    };
    try {
      await Axios.put(`/location/${record?.id}/`, data, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      LoadAPI();
      InactiveLocation("success", "Location Unarchived");
    } catch (err) {
      //console.log(err, "error");
      InactiveLocation("error", "Location UnArchive Failed");
    }
  };

  // eslint-disable-next-line no-unused-vars
  const CreateSuccessfull = (props) => {
    messageApi.open({
      type: "success",
      content: `Work Role detail has been ${props}.`,
      duration: 5,
    });
    LoadAPI();
    if (props === "created") {
      // handleReset();
    }
  };

  const DeleteLocation = (props) => {
    messageApi.open({
      type: props,
      content: `Work Role ${
        props === "success" ? "Deleted" : "had not been Deleted"
      }.`,
      duration: 5,
    });
  };
  const InactiveLocation = (props, message) => {
    messageApi.open({
      type: props,
      content: message,
      duration: 5,
    });
  };

  const columns = [
    {
      title: "Role ID",
      dataIndex: "role_id",
      key: "role_id",
      width: 150,
    },
    {
      title: "Role Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      render: (text, record) => <div>{record?.location?.name || "--"}</div>,
    },
    {
      title: "Job Category",
      dataIndex: "job_category",
      key: "job_category",
    },
    {
      title: "Job Group",
      dataIndex: "job_group",
      key: "job_group",
    },
    {
      title: "Employees",
      dataIndex: "no_of_employees",
      key: "no_of_employees",
      width: 150,
      align: "center",
      render: (text, record) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          {text > 0 ? (
            <Tooltip
              title="View Employees"
              //   onClick={() => props.handleViewClick(record?.id)}
            >
              <Tag
                color="blue"
                style={{
                  fontSize: "1.15rem",
                  width: "2.5rem",
                  height: "2.5rem",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50%",
                  fontWeight: "600",
                  padding: 0,
                }}
              >
                {text}
              </Tag>
            </Tooltip>
          ) : (
            <Tag
              color="default"
              style={{
                fontSize: "1.15rem",
                width: "2.5rem",
                height: "2.5rem",
                display: "flex",
                cursor: "not-allowed",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50%", // Make it a circle
                fontWeight: "600",
                padding: 0, // Remove padding for a perfect circle
              }}
            >
              {text}
            </Tag>
          )}
        </div>
      ),
    },
    ...(updateAuth
      ? [
          {
            title: capitalizeWords("ACTIONS"),
            key: "actions",
            width: 100,
            align: "center",
            render: (text, record) => {
              return active ? (
                <>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <EditableImage
                      handleRowClick={handleRowClick}
                      recordId={record}
                    />
                    {!isSettingsPage && (
                      <Popconfirm
                        title="Archive Location"
                        description=" "
                        //   onConfirm={() => handleDelete(record)}
                        // onCancel={cancel}
                        okText="Yes"
                        cancelText="No"
                        placement="left"
                      >
                        <DeleteTwoTone
                          style={{
                            cursor: "pointer",
                            fontSize: "1.8rem",
                            marginLeft: "0.9rem",
                          }}
                          // onClick={() => {
                          //   handleDelete(record);
                          // }}
                          title="delete"
                          twoToneColor="#eb2f96"
                        />
                      </Popconfirm>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Popconfirm
                      title="Unarchive Location"
                      description=" "
                      onConfirm={() => UnarchiveLocation(record)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                      placement="left"
                    >
                      <SwapOutlined
                        style={{
                          cursor: "pointer",
                          fontSize: "1.8rem",
                          marginLeft: "0.9rem",
                        }}
                        title="unarchive"
                      />
                    </Popconfirm>
                    {!isSettingsPage && (
                      <Popconfirm
                        title="Permanently Delete Location"
                        description=" "
                        onConfirm={() => handleDeletePer(record)}
                        // onCancel={cancel}
                        placement="left"
                        okText="Yes"
                        cancelText="No"
                      >
                        <DeleteTwoTone
                          style={{
                            cursor: "pointer",
                            fontSize: "1.8rem",
                            marginLeft: "0.9rem",
                          }}
                          title="delete"
                          twoToneColor="#eb2f96"
                        />
                      </Popconfirm>
                    )}
                  </div>
                </>
              );
            },
          },
        ]
      : []),
  ];
  const CreateFailed = (props, err) => {
    const messageApi = message;

    const errorMessage = err?.response?.data?.detail?.non_field_errors?.[0];

    messageApi.open({
      type: "error",
      content: errorMessage || `Work role detail has not been ${props}.`,
      duration: 5,
    });
  };
  const showModal = () => {
    setVisible(true);
    setIsEditing(false);
  };

  return (
    <CaSideNav props={isSettingsPage ? CaAdminSettingsMenu : CaAdminMenu}>
      {contextHolder}
      {!isSettingsPage && <SecondaryNav2 menuItems={SecondaryNavCaAdmin} />}
      <CommonTopDetails
        title={active ? "Work Roles Summary" : "Inactive Roles"}
        titleSuffix={`${itemsLength || 0} role(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={!isSettingsPage}
        // showModal={showModal}
        addButtonProps={{
          modalType: "PopUP",
          modalProps: showModal,
        }}
        marginPass={isSettingsPage ? "70px" : "15px"}
        customContent={
          <Switch
            style={{
              backgroundColor: active ? "#50C878" : "#FF0000",
              minWidth: "90px",
            }}
            checked={active}
            disabled={loading}
            onChange={handleSwitchChange}
            checkedChildren="ACTIVE"
            unCheckedChildren="INACTIVE"
          />
        }
      />

      <Spin spinning={loading}>
        <Table
          dataSource={data}
          columns={columns}
          size="small"
          rowKey="id"
          bordered
          className="table-container"
          pagination={false}
          style={{ margin: "1rem" }}
          scroll={{
            x: 1000,
            y: `${remainingViewportHeight(30)}px`,
          }}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "1rem",
          }}
        >
          <Pagination
            size="small"
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            onChange={onPageChange}
            pageSizeOptions={["10", "15", "30", "50", "100"]}
            showQuickJumper
            current={currentPage}
            defaultPageSize={pageSize}
            total={itemsLength}
          />
        </div>
      </Spin>
      <AddEditRoles
        key={editData?.id || "new-role"}
        visible={visible}
        modalData={editData}
        onCancel={handleCancel}
        CreateSuccessfull={CreateSuccessfull}
        CreateFailed={CreateFailed}
        id={userInfo?.data?.organization?.id}
        edit={isEditing}
      />
    </CaSideNav>
  );
};

export default WorkRoleListing;
